<template>
	<div class="pagination">
		<ul v-show="count > size" class="pagination__list">
			<li v-for="i in pages" class="pagination__item" :class="{'pagination__item--active': currentPage === i}"><a @click="handleChange(i)">{{i}}</a></li>
			<!--<li v-if="pages > 3" class="pagination__item"><a href="">...</a></li>-->
			<!--<li v-if="pages > 3" class="pagination__item" :class="{'pagination__item&#45;&#45;active': currentPage === pages}"><a @click="$emit('pageChanged', pages)">{{pages}}</a></li>-->
		</ul>
		<!--<a href="" v-show="count > size" class="pagination__all">see all events</a>-->
	</div>
</template>

<script>
	export default {
		props: {
			count: {
				type: Number,
				default: 0
			},
			currentPage: {
				type: Number,
				default: 1
			},
			size: {
				type: Number,
				default: 10
			}
		},
		data () {
			return {
				number: 0
			}
		},
		methods: {
			handleChange (i) {
				this.$emit('pageChanged', i)
			}
		},
		computed: {
			pages () {
				const pageSize = this.size
				return Math.ceil(+this.count / pageSize)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../styles/variables.scss";

	.pagination {
		padding-bottom: 50px;
		&__list {
			margin: 0;
			margin-bottom: 20px;
			display: flex;
			justify-content: center;
			list-style: none;
			padding: 0;
		}
		&__item {
			cursor: pointer;
			font-size: 20px;
			a {
				padding: 0 10px;
				text-decoration: none;
				color: $gold;
				&:hover {
					color: $black;
				}
			}
			&--active {
				a {
					color: $black;
				}
			}
		}
		&__all {
			font-family: $lato-bold;
			text-decoration: none;
			color: $black;
			letter-spacing: 0.01em;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/PaginationComponent.vue